import "./TopNav.css";

import navDeviantArt from "../images/nav/deviantart.png";
import navHappySpork from "../images/nav/happy_spork.png";

function TopNav() {
  return (
    <div id="top_nav">
        <ul>
          <li>
            <a href="https://neoriceisgood.deviantart.com/">
              <img src={navDeviantArt} alt="Neorice on DeviantArt" />
            </a>
          </li>
          <li>
            <a href="https://www.happyspork.com/">
              <img src={navHappySpork} alt="The Happy Spork" />
            </a>
          </li>
        </ul>
    </div>
  );
}

export default TopNav;